/**
 * Analyse heading elements on the page and disable hyphenation if they are do not contain long
 * words.
 *
 * NOTE: Link collection link headings are analysed in PHP.
 */
(() => {
    /**
     * The amount of characters a word can have before it is considered a long word.
     */
    const threshold = 15;

    let headers = document.querySelectorAll(
        ':is(h1, h2, h3, h4, h5, h6):not(.js-link-collection-link-header)'
    );

    if (!headers.length) {
        return;
    }

    function containsShortWordsOnly(h) {
        const words = h.innerHTML.trim().split(' ');
        for (let i = 0; i < words.length; i++) {
            if (words[i].length > threshold) {
                return false;
            }
        }
        return true;
    }

    headers.forEach((h) => {
        if (containsShortWordsOnly(h)) {
            h.classList.add('-hyphenation-disabled');
        }
    });
})();
